import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  UpdateStressCheckData,
  ActionType,
} from "models/stressCheck/updateStressCheck";
import { IResponse } from "models";
import { httpStatus } from "configs/httpStatus";
import { updateStressCheck } from "services/stressCheck";
import {
  handleSuccesAction,
  handleErrorAction,
} from "./updateStressCheckActions";

function* updateStressCheckSaga({
  payload,
}: {
  payload: UpdateStressCheckData;
}) {
  try {
    const response: IResponse = yield call(updateStressCheck, payload);

    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccesAction(response));
    } else if (response.status === httpStatus.StatusUnauthorized) {
      yield put(handleErrorAction(response.message || ""));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onUpdateStressCheckWatcher() {
  yield takeLatest(
    ActionType.UPDATE_STRESS_CHECK as any,
    updateStressCheckSaga
  );
}

export default [fork(onUpdateStressCheckWatcher)];
